import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const executar = async (requisicao, mensagemErro) => {
    return await requisicao
        .then((res) => res)
        .catch(error => {
            console.error(mensagemErro, error);
            throw error;
        });
};

const apiManutencao = {
    getTabelas: async () =>
        executar(axiosInstance.get(`${apiLink()}api/manutencao/tabelas`), 'Erro ao buscar tabelas de manutenção:'),

    postTabela: async (tabela) =>
        executar(axiosInstance.post(`${apiLink()}api/manutencao/tabela`, tabela), 'Erro ao criar tabela de manutenção:'),

    putTabela: async (id, tabela) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/tabela/${id}`, tabela), 'Erro ao atualizar tabela de manutenção:'),

    deleteTabela: async (id) =>
        executar(axiosInstance.get(`${apiLink()}api/manutencao/tabela/status/${id}`), 'Erro ao excluir tabela de manutenção:'),

    getAvisosEquipamentos: async () =>
        executar(axiosInstance.get(`${apiLink()}api/manutencao/avisos-equipamentos`), 'Erro ao buscar avisos de manutenção dos equipamentos:'),

    carregarModeloPadrao: async () =>
        executar(axiosInstance.post(`${apiLink()}api/manutencao/modelo-padrao`), 'Erro ao carregar modelo padrão de manutenção:'),

    postItem: async (item) =>
        executar(axiosInstance.post(`${apiLink()}api/manutencao/item`, item), 'Erro ao criar item de manutenção:'),

    putItem: async (id, item) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/item/${id}`, item), 'Erro ao atualizar item de manutenção:'),

    deleteItem: async (id) =>
        executar(axiosInstance.get(`${apiLink()}api/manutencao/item/status/${id}`), 'Erro ao excluir item de manutenção:'),

    getTarefasDoDia: async () =>
        executar(axiosInstance.get(`${apiLink()}api/manutencao/tarefas-dia`), 'Erro ao buscar tarefas de manutenção do dia:'),

    concluirTarefa: async (id, executadoPor, observacao) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/tarefa/${id}/concluir`, { executadoPor, observacao }), 'Erro ao concluir tarefa de manutenção:'),

    ignorarTarefa: async (id, executadoPor, observacao) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/tarefa/${id}/ignorar`, { executadoPor, observacao }), 'Erro ao ignorar tarefa de manutenção:'),

    reagendarTarefa: async (id, executadoPor, observacao, novaData) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/tarefa/${id}/reagendar`, { executadoPor, observacao, novaData }), 'Erro ao reagendar tarefa de manutenção:'),

    reabrirTarefa: async (id) =>
        executar(axiosInstance.put(`${apiLink()}api/manutencao/tarefa/${id}/reabrir`), 'Erro ao reabrir tarefa de manutenção:'),
};

export default apiManutencao;
